// @flow
import React from "react"
import Button from "components/Button"
import Bulletpoint from "components//Bulletpoint"
import { Text } from "componentsStyled/Typography/Texts"
import ModalContent from "modals/_Content"
import ModalControls from "modals/_Controls"
import type { Plan } from "data/plans/types"

type Props = {|
  plan: Plan,
  onClick: Function,
  currentStep?: string,
  finalStep?: string,
|}

/**
 * @param {Plan} plan - Subscription plan details
 * @param {Function} onClick - Handler for clicking the modal button
 */
const PlanDetails = ({
  plan,
  onClick,
  currentStep,
  finalStep,
}: Props) => {
  const paragraphs = plan.paragraphs(false)

  return (
    <React.Fragment>
      <ModalContent>
        {paragraphs.map((paragraph, index) => (<Bulletpoint key={index} minimal>{paragraph}</Bulletpoint>))}
      </ModalContent>
      <ModalControls column>
        {currentStep && finalStep
          ? <Text black center>
            Step <Text inline black bold>{currentStep}</Text> of {finalStep}
          </Text>
          : ""}
        <Button fullwidth onClick={onClick}>
          Enter card details
        </Button>
      </ModalControls>
    </React.Fragment>
  )
}

export default PlanDetails



// WEBPACK FOOTER //
// ./src/modals/SubscribePlan/PlanDetails/index.js